var _style, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 399.3 399",
    style: {
      enableBackground: "new 0 0 399.3 399"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:5;stroke-miterlimit:221.8804;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 399.3,
    height: 399
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.9,29.5c13.6,0,24.6,11,24.6,24.6V91c0,13.5-11,24.5-24.6,24.5H54.1c-13.6,0-24.6-11-24.6-24.6V54.1 c0-13.6,11-24.6,24.6-24.6L90.9,29.5 M90.9,27.5H54.1c-14.7,0-26.6,11.9-26.6,26.6V91c0,14.6,11.9,26.5,26.6,26.5H91 c14.6,0,26.5-11.9,26.5-26.6V54.1C117.5,39.4,105.6,27.5,90.9,27.5L90.9,27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.5,53C83.2,53,92,61.7,92,72.5S83.2,92,72.5,92S53,83.2,53,72.5S61.8,53,72.5,53 M72.5,51 C60.6,51,51,60.6,51,72.5S60.6,94,72.5,94S94,84.4,94,72.5S84.4,51,72.5,51L72.5,51z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 96.5,
    cy: 48.5,
    r: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.5,45.8c1.5,0,2.7,1.2,2.7,2.7s-1.2,2.7-2.7,2.7s-2.7-1.2-2.7-2.7S95.1,45.8,96.5,45.8 M96.5,43.8 c-2.6,0-4.7,2.1-4.7,4.7c0,2.6,2.1,4.7,4.7,4.7s4.7-2.1,4.7-4.7C101.2,45.9,99.1,43.8,96.5,43.8L96.5,43.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.e5dfd71e4555174b1d65dcf753132e46.svg";
export { ForwardRef as ReactComponent };